// ANCHOR Model
import {
  createPropsSelectorModel, createSelector,
} from 'react-scoped-model';

// ANCHOR API
import { IFormSubmissionDetails } from '@lyon/utils/api/results/forms';

interface IProps {
  data: IFormSubmissionDetails;
}

export const FormSubmissionDetailsItem = createPropsSelectorModel<IProps>({
  displayName: 'Models.FormSubmissionDetailsItem',
});

export const useFormSubmissionDetailsItemData = createSelector(
  FormSubmissionDetailsItem,
  ({ data }) => data,
);

export const useFormSubmissionDetailsItemDataID = createSelector(
  FormSubmissionDetailsItem,
  ({ data }) => data?.id,
);
